// @ts-nocheck
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.prototype.slice.call((root || document).querySelectorAll(sel));

  // -------------------------
  // Line reveal (dynamic line splitting)
  // -------------------------
  const LINE_REVEAL_SELECTOR = '[data-animation="line-reveal"]';
  const LINE_ELM_CLASS = 'elm';
  const LINE_WRAPPER_CLASS = 'text-line-reveal';
  const LINE_TOP_TOLERANCE = 2;

  const sourceTextByEl = new WeakMap();
  const lastWidthByEl = new WeakMap();
  const roByEl = new WeakMap();
  const allResizeObservers = new Set();

  function extractSourceText(el) {
    const parts = [];
    (el.childNodes || []).forEach((node) => {
      if (node.nodeType === 3) {
        parts.push(node.textContent || '');
        return;
      }
      if (node.nodeType === 1) {
        const n = node;
        if (n.tagName === 'BR') parts.push('\n');
        else parts.push(n.textContent || '');
      }
    });
    return parts
      .join('')
      .replace(/\r\n/g, '\n')
      .replace(/[ \t]+/g, ' ')
      .replace(/ *\n */g, '\n')
      .trim();
  }

  function buildMeasureClone(el, widthPx) {
    const clone = el.cloneNode(false);
    clone.removeAttribute && clone.removeAttribute('id');
    clone.style.position = 'absolute';
    clone.style.left = '-9999px';
    clone.style.top = '0';
    clone.style.width = `${Math.max(1, Math.floor(widthPx))}px`;
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.contain = 'layout style paint';
    clone.style.whiteSpace = 'normal';
    return clone;
  }

  function measureLines(el, sourceText) {
    const width = el.getBoundingClientRect().width;
    if (!width || width < 2) {
      return sourceText ? sourceText.split('\n').map((s) => s.trim()).filter(Boolean) : [];
    }

    const clone = buildMeasureClone(el, width);
    (el.parentElement || document.body).appendChild(clone);

    const allLines = [];
    const segments = sourceText.split('\n').map((s) => s.trim()).filter(Boolean);

    segments.forEach((segment) => {
      const words = segment.split(/\s+/).filter(Boolean);
      if (!words.length) return;

      clone.textContent = '';
      const frag = document.createDocumentFragment();
      const wordSpans = [];

      words.forEach((word, i) => {
        const span = document.createElement('span');
        span.textContent = word;
        span.style.whiteSpace = 'nowrap';
        span.style.display = 'inline-block';
        frag.appendChild(span);
        if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
        wordSpans.push(span);
      });

      clone.appendChild(frag);

      const tops = wordSpans.map((s) => Math.round(s.getBoundingClientRect().top));
      let current = [words[0]];
      let lastTop = tops[0];

      for (let i = 1; i < words.length; i++) {
        if (Math.abs(tops[i] - lastTop) <= LINE_TOP_TOLERANCE) {
          current.push(words[i]);
        } else {
          allLines.push(current.join(' '));
          current = [words[i]];
          lastTop = tops[i];
        }
      }
      if (current.length) allLines.push(current.join(' '));
    });

    clone.remove();
    return allLines;
  }

  function splitIntoLines(el) {
    if (!el) return;
    if (!sourceTextByEl.has(el)) sourceTextByEl.set(el, extractSourceText(el));

    const source = sourceTextByEl.get(el) || '';
    let lines;

    if (el.getAttribute('data-anim-no-split') === 'true') {
      lines = [source.replace(/\n/g, ' ')];
    } else if (el.getAttribute('data-anim-lines') === 'explicit') {
      lines = source.split('\n').map((s) => s.trim()).filter(Boolean);
    } else {
      lines = measureLines(el, source);
    }

    if (!lines || !lines.length) return;

    const targetClass = el.getAttribute('data-anim-class') || 'in-view';
    const isAlreadyRevealed = el.classList.contains(targetClass);

    el.classList.add(LINE_WRAPPER_CLASS);
    if (!el.getAttribute('data-anim-children')) el.setAttribute('data-anim-children', `.${LINE_ELM_CLASS}`);
    if (!el.hasAttribute('data-anim-stagger')) el.setAttribute('data-anim-stagger', '80');

    const fragment = document.createDocumentFragment();
    lines.forEach((lineText) => {
      const lineDiv = document.createElement('div');
      lineDiv.className = LINE_ELM_CLASS;
      const inner = document.createElement('span');
      inner.textContent = lineText;
      lineDiv.appendChild(inner);
      fragment.appendChild(lineDiv);
    });

    el.innerHTML = '';
    el.appendChild(fragment);

    if (isAlreadyRevealed) {
      $$('.' + LINE_ELM_CLASS, el).forEach((child) => child.classList.add(targetClass));
    }
  }

  function initLineReveal() {
    // IMPORTANT:
    // Avoid observing the whole DOM with MutationObserver/ResizeObserver here.
    // Because line-reveal rewrites innerHTML, DOM-wide observers can cascade into
    // repeated re-splitting / re-measuring and freeze the browser.
    //
    // Instead, split:
    // - once on initial load
    // - when Shopify dynamically loads a section
    // - on debounced window resize

    const process = (root) => {
      $$(LINE_REVEAL_SELECTOR, root || document).forEach((el) => {
        const w = Math.round(el.getBoundingClientRect().width);
        const last = lastWidthByEl.get(el);

        // If we've already split and width didn't change, skip.
        if (el.classList.contains(LINE_WRAPPER_CLASS) && last != null && Math.abs(w - last) <= 1) return;

        lastWidthByEl.set(el, w);
        splitIntoLines(el);
      });
    };

    const processAll = () => process(document);

    processAll();

    // Theme editor / async section loads
    document.addEventListener('shopify:section:load', (e) => {
      const target = e && e.target ? e.target : null;
      if (!target) return;
      process(target);
    });

    // Debounced resize to keep splitting correct across breakpoints
    let resizeTimer = 0;
    window.addEventListener(
      'resize',
      () => {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(processAll, 150);
      },
      { passive: true }
    );
  }

  // Use theme's built-in scroll lock (see base.css: html[scroll-lock]{overflow:hidden})
  // with a tiny ref-count so multiple features can lock safely.
  function setScrollLock(shouldLock) {
    const root = document.documentElement;
    const raw = root.getAttribute('data-scroll-lock-count');
    const current = Math.max(0, parseInt(raw || '0', 10) || 0);

    if (shouldLock) {
      const next = current + 1;
      root.setAttribute('scroll-lock', '');
      root.setAttribute('data-scroll-lock-count', String(next));
      return;
    }

    // If something else set scroll-lock without the counter (eg. dialogs), don't fight it.
    if (current === 0) return;
    const next = Math.max(0, current - 1);
    if (next === 0) {
      root.removeAttribute('data-scroll-lock-count');
      root.removeAttribute('scroll-lock');
    } else {
      root.setAttribute('data-scroll-lock-count', String(next));
    }
  }

  function initInView() {
    // Exclude elements whose in-view class is driven by scroll progress (e.g. GSAP onUpdate).
    // Observing these with IntersectionObserver would fight the scroll-driven controller.
    const selector = '[data-animation]:not([data-anim-drive="scroll"])';
    const rootMargin = '-15%';
    const threshold = 0.1;

    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      $$(selector).forEach((el) => {
        const targetClass = el.getAttribute('data-anim-class') || 'in-view';
        el.classList.add(targetClass);

        const childrenSelector = el.getAttribute('data-anim-children');
        if (childrenSelector) {
          const childClass = el.getAttribute('data-anim-child-class') || 'in-view';
          $$(childrenSelector, el).forEach((child) => child.classList.add(childClass));
        }
      });
      return;
    }

    // Re-use observers for identical offsets
    const observers = new Map();
    const pendingTimeoutByElement = new WeakMap();
    const pendingChildTimeoutsByElement = new WeakMap();
    const hasTriggeredOnce = new WeakMap();
    const observedElements = new WeakSet();

    const getObserver = (offset) => {
      const key = offset || rootMargin;
      if (observers.has(key)) return observers.get(key);

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            const el = entry.target;
            const isReversible = el.getAttribute('data-anim-re') === 'true';
            const targetClass = el.getAttribute('data-anim-class') || 'in-view';
            const childrenSelector = el.getAttribute('data-anim-children');
            const childClass = el.getAttribute('data-anim-child-class') || 'in-view';
            const staggerAttr = el.getAttribute('data-anim-stagger');
            const stagger = Number.parseInt(staggerAttr || '0', 10) || 0;

            const clearPendingChildren = () => {
              const timeouts = pendingChildTimeoutsByElement.get(el);
              if (timeouts) {
                timeouts.forEach((id) => clearTimeout(id));
                pendingChildTimeoutsByElement.delete(el);
              }
            };

            const toggleChildren = (shouldAdd) => {
              if (!childrenSelector) return;

              const children = $$(childrenSelector, el);
              clearPendingChildren();

              if (!shouldAdd) {
                children.forEach((child) => child.classList.remove(childClass));
                return;
              }

              if (stagger <= 0) {
                children.forEach((child) => child.classList.add(childClass));
                return;
              }

              const timeouts = [];
              children.forEach((child, idx) => {
                const id = setTimeout(() => {
                  child.classList.add(childClass);
                }, idx * stagger);
                timeouts.push(id);
              });
              pendingChildTimeoutsByElement.set(el, timeouts);
            };

            // Leaving the viewport
            if (!entry.isIntersecting) {
              const pending = pendingTimeoutByElement.get(el);
              if (pending) {
                clearTimeout(pending);
                pendingTimeoutByElement.delete(el);
              }

              clearPendingChildren();
              if (isReversible) {
                el.classList.remove(targetClass);
                toggleChildren(false);
              }
              return;
            }

            // If it already triggered once and isn't reversible, do nothing
            if (!isReversible && hasTriggeredOnce.get(el)) {
              obs.unobserve(el);
              return;
            }

            // Entering the viewport
            const delayAttr = el.getAttribute('data-anim-delay');
            const delay = Number.parseInt(delayAttr || '0', 10) || 0;

            const addClassNow = () => {
              el.classList.add(targetClass);
              toggleChildren(true);
              if (!isReversible) {
                hasTriggeredOnce.set(el, true);
                obs.unobserve(el);
              }
            };

            const existing = pendingTimeoutByElement.get(el);
            if (existing) clearTimeout(existing);

            if (delay > 0) {
              const id = setTimeout(() => {
                pendingTimeoutByElement.delete(el);
                addClassNow();
              }, delay);
              pendingTimeoutByElement.set(el, id);
            } else {
              addClassNow();
            }
          });
        },
        { rootMargin: key, threshold }
      );

      observers.set(key, observer);
      return observer;
    };

    const observeElement = (el) => {
      if (!el || observedElements.has(el)) return;
      observedElements.add(el);

      const offsetAttr = el.getAttribute('data-anim-offset');
      const observer = getObserver(offsetAttr || rootMargin);
      observer.observe(el);
    };

    const scan = (root) => {
      $$(selector, root).forEach(observeElement);
    };

    // Observe all current elements
    scan(document);

    // Observe future elements added to the DOM
    if (!document.body) return;
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // Not an element

          const element = node;
          if (element.matches && element.matches(selector)) observeElement(element);
          if (element.querySelectorAll) scan(element);
        });
      });
    });

    mo.observe(document.body, { childList: true, subtree: true });
  }

  function initFooterYear() {
    const year = String(new Date().getFullYear());
    $$('.curr__year').forEach((el) => {
      if (el && el.textContent !== year) el.textContent = year;
    });
  }

  function initCompoundHeader() {
    const header = $('.compound-header');
    if (!header) return;

    // Build the "nav-roll" hover animation markup (matches HTML project).
    // Shopify menu links/buttons are plain text by default, so the CSS has nothing to animate.
    (function initNavRoll(headerEl) {
      const items = $$('.center-s .nav-ul > .nav-li > a, .center-s .nav-ul > .nav-li > button', headerEl);
      if (!items.length) return;

      const build = (el) => {
        if (el.dataset.navRollInit === '1') return;

        const label = String(el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;

        el.dataset.navRollInit = '1';
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', label);

        // Clear and rebuild (a11y-friendly)
        el.textContent = '';

        const wrap = document.createElement('span');
        wrap.className = 'nav-roll';
        wrap.setAttribute('aria-hidden', 'true');

        const inner = document.createElement('span');
        inner.className = 'nav-roll__inner';

        const lineA = document.createElement('span');
        lineA.className = 'nav-roll__line nav-roll__line--a';
        lineA.textContent = label;

        const lineB = document.createElement('span');
        lineB.className = 'nav-roll__line nav-roll__line--b';
        lineB.textContent = label;

        inner.appendChild(lineA);
        inner.appendChild(lineB);
        wrap.appendChild(inner);

        const sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.textContent = label;

        el.appendChild(wrap);
        el.appendChild(sr);

        const setHeightVar = () => {
          const cs = window.getComputedStyle(el);
          const lh = parseFloat(cs.lineHeight);
          const h = Number.isFinite(lh) ? Math.ceil(lh) : Math.ceil(el.getBoundingClientRect().height || 22);
          wrap.style.setProperty('--nav-roll-h', h + 'px');
        };
        setHeightVar();
        window.addEventListener('resize', setHeightVar, { passive: true });
      };

      items.forEach(build);
    })(header);

    document.body.style.setProperty('--header-height', `${Math.round(header.offsetHeight)}px`);

    // Product, policy, contact & hero pages: make header transparent over the hero.
    const isProductPage = /\/products\//i.test(window.location.pathname || '');
    const isHomePage = document.body.classList.contains('is-home');
    const mainTemplate = document.getElementById('MainContent')?.getAttribute('data-template') || '';
    const isPolicyPage = mainTemplate === 'page.policy';
    const isContactPage = mainTemplate === 'page.contact';
    const isHowToUsePage = mainTemplate === 'page.how-to-use';
    if (isProductPage || isPolicyPage || isContactPage || isHowToUsePage) {
      header.classList.remove('bg');
    }
    if (isHomePage) {
      header.classList.remove('bg');
      header.classList.add('transparent');
    }

    const shopBtn = $('[data-shop-toggle]', header);
    const shopMega = $('[data-shop-mega]', header);
    const shopItem = $('[data-shop-nav]', header);
    let open = false;
    let closeTimer = 0;

    const setOpen = (v) => {
      open = v;
      if (!shopBtn || !shopMega) return;
      shopBtn.setAttribute('aria-expanded', String(open));
      shopMega.classList.toggle('is-open', open);
      shopItem && shopItem.classList.toggle('is-open', open);
      header.classList.toggle('is-mega-open', open);
    };

    const clearClose = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = 0;
    };
    const scheduleClose = () => {
      clearClose();
      closeTimer = window.setTimeout(() => setOpen(false), 120);
    };

    if (shopBtn && shopMega && header.dataset.shopMegaBound !== '1') {
      header.dataset.shopMegaBound = '1';
      // iPad (and any touch + hover device) synthesizes mouseenter on first tap,
      // then mouseleave before click — which closes the mega and cancels the link.
      // Only auto-open on true mouse pointers; everyone else taps to toggle.
      const hoverOnlyPointer =
        window.matchMedia('(hover: hover)').matches &&
        window.matchMedia('(any-pointer: fine)').matches &&
        !window.matchMedia('(any-pointer: coarse)').matches;

      shopBtn.addEventListener('click', (e) => {
        // Mouse: hover already opens the mega; let the Shop link go to /collections/shop.
        // Touch: first tap opens the mega (so dropdown items stay tappable); second tap follows the link.
        if (hoverOnlyPointer) return;
        if (open) return;
        e.preventDefault();
        e.stopPropagation();
        clearClose();
        setOpen(true);
      });

      if (hoverOnlyPointer) {
        shopItem && shopItem.addEventListener('mouseenter', () => setOpen(true));
        shopItem && shopItem.addEventListener('mouseleave', scheduleClose);
        shopMega.addEventListener('mouseenter', clearClose);
        shopMega.addEventListener('mouseleave', scheduleClose);
      }

      document.addEventListener('click', (e) => {
        if (!shopMega.classList.contains('is-open')) return;
        if (shopItem && shopItem.contains(e.target)) return;
        setOpen(false);
      });
    }

    // Image previews on hover/focus
    let previewSeq = 0;
    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const onPreviewIntent = (e) => {
      const a = e.target && e.target.closest && e.target.closest('[data-preview-target][data-preview-src]');
      if (!a || !shopMega) return;
      const target = a.getAttribute('data-preview-target');
      const src = a.getAttribute('data-preview-src');
      if (!target || !src) return;

      const img = shopMega.querySelector('[data-preview-img="' + target + '"]');
      if (!img || img.getAttribute('src') === src) return;

      // Reduced motion: swap instantly.
      if (prefersReduced) {
        img.setAttribute('src', src);
        return;
      }

      const seq = ++previewSeq;
      img.dataset.previewSeq = String(seq);

      // Preload so we never fade to blank.
      const pre = new Image();
      pre.src = src;

      const afterReady = () => {
        if (img.dataset.previewSeq !== String(seq)) return;

        // Ensure we don't stack handlers/timers.
        if (img.__compoundPreviewEnd) img.removeEventListener('transitionend', img.__compoundPreviewEnd);
        if (img.__compoundPreviewTimer) window.clearTimeout(img.__compoundPreviewTimer);

        const commitSwap = () => {
          if (img.dataset.previewSeq !== String(seq)) return;
          img.setAttribute('src', src);
          window.requestAnimationFrame(() => {
            if (img.dataset.previewSeq !== String(seq)) return;
            img.classList.remove('is-preview-out');
          });
        };

        const onEnd = (ev) => {
          if (ev && ev.target !== img) return;
          if (ev && ev.propertyName && ev.propertyName !== 'opacity') return;
          img.removeEventListener('transitionend', onEnd);
          img.__compoundPreviewEnd = null;
          commitSwap();
        };

        img.__compoundPreviewEnd = onEnd;
        img.addEventListener('transitionend', onEnd);

        // Trigger fade/scale out, then swap on end.
        img.classList.remove('is-preview-out');
        // eslint-disable-next-line no-unused-expressions
        img.offsetWidth;
        img.classList.add('is-preview-out');

        img.__compoundPreviewTimer = window.setTimeout(
          () => onEnd({ target: img, propertyName: 'opacity' }),
          220
        );
      };

      if (typeof pre.decode === 'function') {
        pre.decode().then(afterReady).catch(afterReady);
        return;
      }
      if (pre.complete) afterReady();
      else {
        pre.addEventListener('load', afterReady, { once: true });
        pre.addEventListener('error', afterReady, { once: true });
      }
    };

    if (shopMega) {
      shopMega.addEventListener('mouseover', onPreviewIntent);
      shopMega.addEventListener('focusin', onPreviewIntent);
    }

    // Mobile menu
    const overlay = $('[data-mobile-overlay]');
    const mobileMenu = $('[data-mobile-menu]');
    const menuBtn = $('[data-mobile-menu-toggle]', header);
    const menuTop = mobileMenu ? $('.mobile-menu__top', mobileMenu) : null;
    const homeParent = menuBtn && menuBtn.parentElement;
    const homeNext = menuBtn && menuBtn.nextSibling;
    let moveBackTimer = 0;
    let raf1 = 0;
    let raf2 = 0;

    const moveBtnHome = () => {
      if (!menuBtn || !homeParent) return;
      if (homeNext) homeParent.insertBefore(menuBtn, homeNext);
      else homeParent.appendChild(menuBtn);
    };

    const setMobile = (v) => {
      if (!overlay || !mobileMenu || !menuBtn) return;

      if (moveBackTimer) window.clearTimeout(moveBackTimer);
      if (raf1) window.cancelAnimationFrame(raf1);
      if (raf2) window.cancelAnimationFrame(raf2);
      moveBackTimer = raf1 = raf2 = 0;

      overlay.classList.toggle('is-open', v);
      mobileMenu.classList.toggle('is-open', v);
      mobileMenu.setAttribute('aria-hidden', String(!v));
      header.classList.toggle('is-mobile-open', v);
      setScrollLock(v);

      menuBtn.setAttribute('aria-expanded', String(v));
      menuBtn.setAttribute('aria-label', v ? 'Close menu' : 'Open menu');

      if (!menuTop || !homeParent) {
        menuBtn.classList.toggle('open', v);
        return;
      }

      if (v) {
        menuBtn.classList.remove('open');
        menuTop.appendChild(menuBtn);
        menuBtn.classList.add('is-in-menu');
        raf1 = window.requestAnimationFrame(() => {
          // eslint-disable-next-line no-unused-expressions
          menuBtn.offsetWidth;
          raf2 = window.requestAnimationFrame(() => menuBtn.classList.add('open'));
        });
      } else {
        menuBtn.classList.remove('open');
        menuBtn.classList.remove('is-in-menu');
        moveBackTimer = window.setTimeout(moveBtnHome, 260);
      }
    };
    if (menuBtn && overlay && mobileMenu) {
      menuBtn.addEventListener('click', () => setMobile(!mobileMenu.classList.contains('is-open')));
      overlay.addEventListener('click', () => setMobile(false));
      mobileMenu.addEventListener('click', (e) => {
        const a = e.target && e.target.closest && e.target.closest('a');
        if (a) setMobile(false);
      });
    }

    // Accordion (shop) in mobile menu
    const accWrap = $('[data-mobile-accordion]');
    const accBtn = $('[data-mobile-shop-toggle]');
    const accPanel = $('#mobile-shop-panel');
    const setAcc = (v) => {
      if (!accBtn || !accPanel || !accWrap) return;
      accBtn.setAttribute('aria-expanded', String(v));
      accPanel.hidden = !v;
      accWrap.classList.toggle('is-open', v);
    };
    if (accBtn && accPanel) accBtn.addEventListener('click', () => setAcc(accPanel.hidden));

    // Cart button proxy: open Shopify cart drawer trigger (keeps Shopify plumbing intact)
    const openCart = () => {
      const real = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (real && typeof real.click === 'function') real.click();
      else window.location.href = '/cart';
    };
    $$('[data-compound-cart-trigger]', header).forEach((btn) => {
      btn.addEventListener('click', openCart);
    });
  }

  // Header scroll behavior (slide up/down)
  const SCROLL_THRESHOLD = 100;
  let lastY = window.scrollY || 0;
  let ticking = false;

  function applyHeaderScrollState() {
    ticking = false;
    const header = $('.compound-header');
    if (!header) return;

    const y = window.scrollY || 0;
    const dy = y - lastY;
    const absDy = Math.abs(dy);
    const menusOpen = header.classList.contains('is-mobile-open') || header.classList.contains('is-mega-open');
    
    // Page types that support transparency
    const isGiftCardPage =
      document.body.classList.contains('is-gift-card-page') ||
      document.documentElement.classList.contains('is-gift-card-page');
    const isProductPage = /\/products\//i.test(window.location.pathname || '');
    const isHomePage = document.body.classList.contains('is-home');
    const mainEl = document.getElementById('MainContent');
    const mainTemplateAttr = mainEl && mainEl.getAttribute('data-template');
    const isPolicyPage = mainTemplateAttr === 'page.policy';
    const isContactPage = mainTemplateAttr === 'page.contact';
    const isHowToUsePage = mainTemplateAttr === 'page.how-to-use';
    const is404Page =
      document.body.classList.contains('is-404') ||
      (mainTemplateAttr != null && String(mainTemplateAttr).indexOf('404') !== -1);
    const isTransparentPage =
      !isGiftCardPage &&
      (isProductPage ||
        isHomePage ||
        isPolicyPage ||
        isContactPage ||
        isHowToUsePage ||
        is404Page);

    header.classList.toggle('is-scrolled', y > SCROLL_THRESHOLD);
    if (isTransparentPage) {
      header.classList.toggle('transparent', y <= SCROLL_THRESHOLD && !menusOpen);
    } else {
      header.classList.remove('transparent');
      header.classList.add('bg');
    }
    
    if (y <= SCROLL_THRESHOLD || menusOpen) {
      header.classList.remove('is-hidden');
    } else if (absDy > 1) {
      if (dy > 0) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
    }
    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(applyHeaderScrollState);
  }

  function init() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    try {
      // Must run before initInView so in-view can stagger `.elm` children.
      initLineReveal();
      initInView();
      initFooterYear();
      initCompoundHeader();

      // Listen for section reloads (e.g. cart updates that refresh the header)
      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.classList.contains('compound-header') || e.target.querySelector('.compound-header')) {
          initCompoundHeader();
          applyHeaderScrollState();
        }
      });

      // Global listeners (added once)
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const header = $('.compound-header');
        if (header) {
          // Note: these rely on having local scope or being global. 
          // Since they were inside initCompoundHeader, we might need to expose them or find them.
          // For simplicity, we'll let the next init call handle them or use query selectors.
          const shopMega = $('[data-shop-mega]', header);
          if (shopMega) shopMega.classList.remove('is-open');
          const mobileMenu = $('[data-mobile-menu]');
          if (mobileMenu) {
            mobileMenu.classList.remove('is-open');
            const overlay = $('[data-mobile-overlay]');
            if (overlay) overlay.classList.remove('is-open');
            header.classList.remove('is-mobile-open');
          }
          header.classList.remove('is-mega-open');
        }
      });

      applyHeaderScrollState();
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('[compound-global.js] init error:', err);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Our Products is now section-scoped (compound-our-products.js).
})();

